import { useEffect } from 'react'

/**
 * Injects (or updates) a single `<script type="application/ld+json">` tag
 * identified by a stable `id`, following the same manual-DOM-manipulation
 * style as `useDocumentMeta` rather than pulling in a new dependency.
 *
 * Pass `data: null` to remove the tag (e.g. while the page has nothing
 * meaningful to describe yet).
 */
export function useJsonLd(scriptId: string, data: object | null): void {
  useEffect(() => {
    if (!data) return

    let script = document.getElementById(scriptId)
    let created = false
    if (!script) {
      script = document.createElement('script')
      script.id = scriptId
      script.setAttribute('type', 'application/ld+json')
      document.head.appendChild(script)
      created = true
    }
    script.textContent = JSON.stringify(data)

    return () => {
      if (created) script?.remove()
    }
  }, [scriptId, data])
}
